import { useUiStore } from "@/shared/stores/uiStore";
import { EyeOpen } from "../../assets/EyeOpen";
import { EyeClosed } from "../../assets/EyeClosed";
import styles from "./MaskToggleButton.module.scss";

export const MaskToggleButton = () => {
  const { isMasked, toggleMask } = useUiStore();

  return (
    <button onClick={toggleMask} className={styles.maskButton}>
      {isMasked ? <EyeClosed /> : <EyeOpen />}
    </button>
  );
};
